import React from 'react';
import { motion } from 'framer-motion';

const SECTION_INITIAL = { opacity: 0, y: 16 };
const SECTION_VISIBLE = { opacity: 1, y: 0 };
const IN_VIEW_OPTS = { once: true, amount: 0.2 };
const SECTION_TRANSITION = { duration: 0.45 };

export const LegalSection = ({ section, index }) => (
  <motion.section
    initial={SECTION_INITIAL}
    whileInView={SECTION_VISIBLE}
    viewport={IN_VIEW_OPTS}
    transition={SECTION_TRANSITION}
    className="py-8 border-t border-white/10 first:border-t-0"
    data-testid={`legal-section-${index}`}
  >
    <h2 className="text-base md:text-lg font-semibold text-white mb-4">{section.heading}</h2>
    {section.body?.map((p) => (
      <p key={p} className="text-sm md:text-base text-gray-300 leading-relaxed mb-3">{p}</p>
    ))}
    {section.items && (
      <ul className="space-y-2.5">
        {section.items.map((item) => (
          <li key={item} className="flex gap-3 text-sm md:text-base text-gray-300 leading-relaxed">
            <span className="mt-2.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-orange-500" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    )}
  </motion.section>
);
